/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";

export class InvoiceDateChangeRequestDtoModel extends JSONable {

  uuid: string | null = null;

  owner: string | null = null;

  deleted: string | null = null;

  invoiceUuid: string | null = null;

  newInvoiceStartDate: string | null = null;

  comment: string | null = null;

  attachments: string | null = null;

}
